import Axios from "axios";
import { headers, SALES_SCHEDULING } from "../../config";

export function getPlants() {
    return Axios.get(`${SALES_SCHEDULING}/plants`, { headers: headers() });
}

export default {
    all: getPlants
}